
<div class="flex-row">
  <mat-card class="card-width" matRipple  (click)="gotoUser()">
    <mat-card-content>
      <p class="color-green">{{ activeUserCount < 10 ? '0'  + activeUserCount: activeUserCount }}</p>
      <p>{{"Active_Users" | translate }}</p>
    </mat-card-content>
  </mat-card>
  
  <mat-card class="card-width" matRipple (click)="gotoInactiveUser()">
    <mat-card-content>
      <p class="color-red">{{ blockedUsers?.length < 10 ? '0' + blockedUsers?.length : blockedUsers?.length }}</p>
      <p>{{ "Blocked_Users" | translate }}</p>
    </mat-card-content>
  </mat-card>

  @if (userHasAccess) {
  <mat-card class="card-width" matRipple (click)="gotoSubscriptions()">
    <mat-card-content>
      <p class="color-warning">{{ subscriptionCount | number: '2.0' }}</p>
      <p>Subscriptions</p>
    </mat-card-content>
  </mat-card>
  }
</div>
